import React, { useState, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (!token) return;

    setLoading(true);

    fetch('/api/auth/verify', {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(response => {
        if (response.ok) {
          setLoading(false);
        } else {
          localStorage.removeItem('token');
          navigate('/admin/login');
        }
      })
      .catch(() => {
        localStorage.removeItem('token');
        navigate('/admin/login');
      });
  }, [token, navigate]);

  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  if (loading) {
    return <div>Verificando sesión...</div>;
  }

  return <>{children}</>;
};

export default PrivateRoute;